import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LoginComponent from '../../Component/Login/LoginComponent'
import { useAuth } from '../../Context/AuthContext'

export default function Login() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()

  // Redirect already-authenticated users straight to the app
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/home')
    }
  }, [isAuthenticated, isLoading, navigate])

  return <LoginComponent />
}
